import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard, EducationalBlock } from '../finance/shared';

const MuscleGainCaloriesCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [maintenance, setMaintenance] = useState('2.500');
  const [surplus, setSurplus] = useState('300');
  const [resultState, setResultState] = useState<any>(null);

  const calculate = () => {
    const m = parseFloat(parseBrazilianNumber(maintenance)) || 0;
    const s = parseFloat(parseBrazilianNumber(surplus)) || 0;
    if (m <= 0 || s < 0) return;

    const target = m + s;
    const res = { target, maintenance: m, surplus: s };
    setResultState(res);
    onResultChange([
      { label: 'Manutenção', value: `${m} kcal` },
      { label: 'Superávit', value: `${s} kcal` },
      { label: 'Meta Diária', value: `${target.toFixed(0)} kcal/dia` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <FormField label="Calorias de Manutenção" value={maintenance} onChange={setMaintenance} required isNumeric type="text" />
          <FormField label="Superávit Desejado (kcal)" value={surplus} onChange={setSurplus} required isNumeric type="text" helpText="Recomendado: 250-500 kcal" />
        </div>

        <div className="flex justify-center mb-8">
          <button
            onClick={calculate}
            className="px-12 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:shadow-accent-hover hover:scale-[1.02] transition-all flex items-center justify-center gap-2"
          >
            <Icon name="play" className="w-5 h-5" />
            Calcular Meta de Ganho
          </button>
        </div>

        {resultState && (
          <ResultCard title="Meta de Consumo Diário" value={`${resultState.target.toFixed(0)} kcal/dia`} description="Para ganho de massa muscular" color="indigo" />
        )}
      </div>

      <EducationalBlock
        title="Dicas para Hipertrofia"
        tips={[
          'Um superávit calórico moderado (250-500 kcal) minimiza o ganho de gordura',
          'Consuma proteínas suficientes (geralmente 1.6g a 2.2g por kg de peso)',
          'O treino de força é essencial para direcionar as calorias extras para o músculo',
          'A consistência é mais importante que grandes variações diárias'
        ]}
      />
    </div>
  );
};

export default MuscleGainCaloriesCalculator;
